import { Injectable, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Item } from 'src/app/modules/order/interface/item';

@Injectable()
export class ItemService {

  /**
   * Die im Service gesetzten Items
   *
   * @var Item[]
   */
  private items: BehaviorSubject<Item[]>;

  constructor() {
    this.items = new BehaviorSubject(null);
  }

  /**
   * @returns Observable
   */
  public getItems = () => {
    return this.items.asObservable();
  }

  /**
   * Funktion zum Setzen der Items
   *
   * @param items
   */
  public setItems = (items: Item[]) => {
    this.items.next(items);
  }

  /**
   * Fügt ein neues Item zu den bereits vorhandenen Items hinzu
   *
   * @param item
   */
  public addItem = (item: Item) => {
    let tempItems = [];

    if (this.items.value !== null) {
      tempItems = this.items.value;
    }

    tempItems.push(item);
    this.items.next(tempItems);
  }

  /**
   * Entfernt ein vorhandenes Produkt aus den im Service gesetzten
   *
   * @param idProduct
   */
  public removeItem = (idProduct: number) => {
    let tempItems = this.items.value;
    const index = this.items.value.findIndex(item => {
      return item.IdProduct === idProduct;
    });

    const length = this.items.value.length;

    if (length > 1) {
      tempItems.splice(index, 1);
    } else {
      tempItems = null;
    }

    this.items.next(tempItems);
  }

  /**
   * Setzt die gesetzten Items im Service auf null
   */
  public clearItems = () => {
    this.items.next(null);
  }

  /**
   * Funktion zum manipulieren der Anzahl einer Position
   *
   * @param idProduct
   * @param mode
   */
  public quantityChange = (idProduct: number, mode: string) => {
    const tempItems = this.items.value;
    const index = this.items.value.findIndex(item => {
      return item.IdProduct === idProduct;
    });

    if (mode === 'up') {
      tempItems[index].Quantity++;
    } else {
      if (tempItems[index].Quantity > 1) {
        tempItems[index].Quantity--;
      } else {
        this.removeItem(idProduct);
      }
    }
  }

}
